import React, { memo } from 'react';

import { BRAND_NAME } from '~/common/constants/brand';
import logos from '~/components/Shared/ProviderLogo/logos';

import { Theme } from '../../types/Theme';
import { Box } from '../Box/Box';
import { Image } from '../Image/Image';

type LogoType =
  | 'logo-dark'
  | 'logo-dark-icon'
  | 'logo-light'
  | 'logo-light-icon';

interface Props {
  mode?: 'full' | 'icon';
  theme?: Theme;
  provider?: keyof typeof logos;
  size?: 's' | 'm';
}

export const Logo = memo(
  ({ mode = 'full', theme = 'dark', provider }: Props) => {
    const isDarkTheme = theme === 'dark';
    const isProvider = provider && !!logos[provider];
    const isIcon = mode === 'icon';
    const image = `logo${isDarkTheme ? '-light' : '-dark'}${
      isIcon ? '-icon' : ''
    }`;

    if (isProvider) {
      return (
        <Box
          as="img"
          alt={`${provider} logo`}
          src={logos[provider]}
          h="48px"
          w="48px"
        />
      );
    }

    return (
      <Image
        alt={`${BRAND_NAME} logo`}
        flex="none"
        h="height.s"
        image={image as LogoType}
        title={BRAND_NAME}
        w="auto"
      />
    );
  },
);
